import { createFileRoute } from "@tanstack/react-router"

import { Stack } from "@chakra-ui/react"
import Catalog from "../components/Catalog"

import useFrame from "../hooks/useFrame"

const CatalogRoute: React.FC = () => {
  const { containerRef } = useFrame()
  return (
    <>
      <Stack ref={containerRef}>
        <Catalog />
      </Stack>
    </>
  )
}

export const Route = createFileRoute("/catalog")({
  component: CatalogRoute,
})
